import React, { useEffect, useState } from 'react';
import './ippe-top.m.css';

const IppeTop = () => {

  const [ippeData, setIppeData] = useState(null);
  const [openId, setOpenId] = useState(false);

  const toggle = (id) => {
    setOpenId(openId === id ? false : id);
  };

  useEffect(() => {
    const fetchIppeData = async () => {
      try {
        const response = await fetch(`/api/v1/authors/ippe`);
        const data = await response.json();
        setIppeData(data.author);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchIppeData();
  }, []);

  return (
    <div styleName="urheilu-ippe-top">
      <div styleName="author-bio">
        <div styleName="author-img">
          <a href="/urheilu-ippe">
            <img src={ippeData && ippeData["avatar-url"]} alt={ippeData && ippeData.name} styleName="user" />
          </a>
        </div>
        <div styleName="info">
          {ippeData && ippeData.name && <h1>{ippeData && ippeData.name}</h1>}
          {ippeData && ippeData.bio && <div>{ippeData && ippeData.bio}</div>}
        </div>
      </div>
      <div styleName="button-row">
        <div styleName="sport">
          <button className="Pesäpallo" onClick={() => toggle('pesäpallo')}>
            <p>Pesäpallo</p><i className="ri-arrow-drop-down-line"></i>
          </button>
          {openId === 'pesäpallo' && (
            <ul styleName="serie-list">
              <li><a href="/pesis-ippe/pohjalaistulokset">Pohjalaistulokset</a></li>
              <li><a href="/pesis-ippe/miesten-superpesis">Miesten Superpesis</a></li>
              <li><a href="/pesis-ippe/naisten-superpesis">Naisten Superpesis</a></li>
              <li><a href="/pesis-ippe/miesten-ykkospesis">Miesten Ykköspesis</a></li>
              <li><a href="/pesis-ippe/naisten-ykkospesis">Naisten Ykköspesis</a></li>
              <li><a href="/pesis-ippe/miesten-suomensarja">Miesten Suomensarja</a></li>
              <li><a href="/pesis-ippe/naisten-suomensarja">Naisten Suomensarja</a></li>
              <li><a href="/pesis-ippe/miesten-maakuntasarja">Miesten maakuntasarja</a></li>
              <li><a href="/pesis-ippe/naisten-maakuntasarja">Naisten maakuntasarja</a></li>
              <li><a href="/pesis-ippe/poikien-superpesis">Poikien Superpesis</a></li>
              <li><a href="/pesis-ippe/tyttojen-superpesis">Tyttöjen Superpesis</a></li>
              <li><a href="/pesis-ippe">Katso kaikki</a></li>
            </ul>
          )}
        </div>
        <div styleName="sport">
          <button className="Futis" onClick={() => toggle('futis')}>
            <p>Jalkapallo</p><i className="ri-arrow-drop-down-line"></i>
          </button>
          {openId === 'futis' && (
            <ul styleName="serie-list">
              <li><a href="/futis-ippe/pohjalaistulokset">Pohjalaistulokset</a></li>
              <li><a href="/futis-ippe/veikkausliiga">Veikkausliiga</a></li>
              <li><a href="/futis-ippe/ykkosliiga">Ykkösliiga</a></li>
              <li><a href="/futis-ippe/miesten-ykkonen">Ykkönen</a></li>
              <li><a href="/futis-ippe/miesten-kakkonen">Miesten Kakkonen</a></li>
              {/*<li><a href="/futis-ippe/miesten-suomen-cup">Miesten Suomen Cup</a></li>*/}
              <li><a href="/futis-ippe/miesten-liigacup">Liigacup</a></li>
              <li><a href="/futis-ippe/kansallinen-liiga">Kansallinen Liiga</a></li>
              <li><a href="/futis-ippe/naisten-kansallinen-ykkonen">Kansallinen Ykkönen</a></li>
              <li><a href="/futis-ippe/naisten-kakkonen">Naisten Kakkonen</a></li>
              {/*<li><a href="/futis-ippe/naisten-suomen-cup">Naisten Suomen Cup</a></li>*/}
              <li><a href="/futis-ippe">Katso kaikki</a></li>
            </ul>
          )}
        </div>
        <div styleName="sport">
          <button className="Salibandy" onClick={() => toggle('salibandy')}>
            <p>Salibandy</p><i className="ri-arrow-drop-down-line"></i>
          </button>
          {openId === 'salibandy' && (
            <ul styleName="serie-list">
              <li><a href="/salibandy-ippe/pohjalaistulokset">Pohjalaistulokset</a></li>
              <li><a href="/salibandy-ippe/miesten-f-liiga">Miesten F-liiga</a></li>
              <li><a href="/salibandy-ippe/naisten-f-liiga">Naisten F-liiga</a></li>
              <li><a href="/salibandy-ippe/miesten-divari">Miesten Divari</a></li>
              <li><a href="/salibandy-ippe/naisten-divari">Naisten Divari</a></li>
              <li><a href="/salibandy-ippe/miesten-suomisarja">Miesten Suomisarja</a></li>
              <li><a href="/salibandy-ippe/naisten-suomisarja">Naisten Suomisarja</a></li>
              <li><a href="/salibandy-ippe/salibandy-p19-sm-sarja">P19 SM-sarja</a></li>
              <li><a href="/salibandy-ippe/salibandy-p22-sm-sarja">P22 SM-sarja</a></li>
              <li><a href="/salibandy-ippe">Katso kaikki</a></li>
            </ul>
          )}
        </div>
        <div styleName="sport">
          <button className="Jääkiekko" onClick={() => toggle('jääkiekko')}>
            <p>Jääkiekko</p><i className="ri-arrow-drop-down-line"></i>
          </button>
          {openId === 'jääkiekko' && (
            <ul styleName="serie-list">
              <li><a href="/kiekko-ippe/pohjalaistulokset">Pohjalaistulokset</a></li>
              <li><a href="/kiekko-ippe/sm-liiga">Liiga</a></li>
              <li><a href="/kiekko-ippe/naisten-liiga">Auroraliiga</a></li>
              <li><a href="/kiekko-ippe/mestis">Mestis</a></li>
              <li><a href="/kiekko-ippe/naisten-mestis">Naisten Mestis</a></li>
              <li><a href="/kiekko-ippe/suomi-sarja">Suomi-sarja</a></li>
              <li><a href="/kiekko-ippe/ii-divisioona">II-divisioona</a></li>
              <li><a href="/kiekko-ippe/iii-divisioona">III-divisioona</a></li>
              <li><a href="/kiekko-ippe/jaakiekko-u20-sm-sarja">Pojat U20 SM-sarja</a></li>
              <li><a href="/kiekko-ippe">Katso kaikki</a></li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}


export { IppeTop };
